<div class="box ml-2 mr-2">
    <div class="box-header">
    
     
      <div class="grid-filter">
        <div class="actions">
          <div class="row">
             <div class="col-md-6 flex-align-center">
                         
            </div> 
            <div class="col-md-6 flex-align-center justify-md-right">
              <mat-form-field>
                <mat-label>{{'Search' | translate}}</mat-label>
                <input matInput placeholder="Placeholder" (keyup)="applyFilter($event.target.value)"  />
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
              
            </div>
          </div>
        </div>
      </div>
      
    </div>
   
    <div class="box-body mt-2">
    <!-- <div class="table-responsive"> -->
        <mat-table class="order-summary-table" [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">
            <!-- Position Column -->
            <ng-container matColumnDef="storeNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Store #'  | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.storeNumber }} </mat-cell>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="storeName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Pharmacy Name' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.storeName }} </mat-cell>
            </ng-container>
          
            <!-- Weight Column -->
            <!-- <ng-container matColumnDef="storeAddress">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Street Address' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.storeAddress }} </mat-cell>
            </ng-container> -->

            <!-- Weight Column -->
            <ng-container matColumnDef="civicNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Civic Number' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.civicNumber }} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="suiteNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Suite Number' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.suiteNumber }} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="streetName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Street Name' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.streetName }} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="streetType">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Street Type' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.streetType }} </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="streetDirection">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Street Direction' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.streetDirection }} </mat-cell>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="city">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'City' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.city }} </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="provinceCode">
              <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Province' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.provinceCode }} </mat-cell>
            </ng-container>
          
            <ng-container matColumnDef="details">
              <mat-header-cell *matHeaderCellDef> {{'Details' | translate}} </mat-header-cell>
              <mat-cell *matCellDef="let element"> 
                  <button mat-icon-button matTooltip="{{'ViewDetailsTooltip' | translate}}" (click)="viewStoreDetails(element)">
                <mat-icon>visibility</mat-icon>

              </button></mat-cell>
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>
          
         </div>
        
    <div class="box-footer">
      <mat-paginator [pageSizeOptions]="[15, 30, 45]" showFirstLastButtons></mat-paginator>
     </div>
    
    <div class="col">
      <div class="text-right">
    <button  mat-raised-button class="ml-auto" [disabled]="exportButton" (click)="downloadStoreData()">{{'Export' | translate}}</button>
  </div>
  </div>
  </div>